import { Modal, Switch, Tag } from 'antd';
import { CalendarTickIcon, ForwardIcon } from 'assets/icon';
import moment from 'moment';
import React, { Fragment, useState } from 'react';
import DOMPurify from 'dompurify';
import { imgUrl } from 'utils/url';
import ModalConfirmation from 'components/ModalConfirmation';
import { bulkApproval as bulkApprovalInformation } from 'state/actions/information';
import { bulkApproval as bulkApprovalMedia } from 'state/actions/media';
import { bulkApproval as bulkApprovalPoi } from 'state/actions/pois';
import MFAImage from 'assets/mfa.png';
import { useDispatch } from 'react-redux';
import { fetchNotifications } from 'state/actions/notification';
import './ModalDetailNotification.css';

function ModalDetailNotification({
  isVisible,
  data,
  onUpdate,
  onCancel,
  setData,
  loading,
  currentStatusFilter = 'all',
}) {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState({
    isOpen: false,
    title: '',
    description: '',
    icon: '',
    mediaId: [],
    informationId: [],
    status: 'approved',
  });

  const getStatus = (status) => {
    // console.log(data.statu, 'data status');
    if (status)
      switch (status) {
        case 'pending':
          return <Tag color="gold">Pending Approval</Tag>;
        case 'approved':
          return <Tag color="green">Approved</Tag>;
        case 'declined':
          return <Tag color="red">Declined</Tag>;
        default:
          return <span>-</span>;
      }
  };

  const items = data
    ? [
        {
          key: '1',
          label: 'Title',
          children: data.name,
        },

        // {
        //   key: '2',
        //   label: 'Page',
        //   children: data.page,
        // },
        // {
        //   key: '2',
        //   label: 'Notes',
        //   children: data.notes,
        // },
        // {
        //   key: '3',
        //   label: 'Unit Number',
        //   children: data.unitnumber.join(', '),
        // },
        // {
        //   key: '4',
        //   label: 'Site',
        //   children: data.propertiesName,
        // },
        // {
        //   key: '5',
        //   label: 'Status',
        //   children: getStatus(data.status),
        // },
      ]
    : [];

  const onChange = (checked) => {
    setData({ ...data, status: checked ? 'done' : 'ongoing' });
    onUpdate({ ...data, status: checked ? 'done' : 'ongoing' });
  };

  const HtmlView = ({ htmlString }) => {
    const sanitizedHtmlString = DOMPurify.sanitize(htmlString);
    return (
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: sanitizedHtmlString }}
        style={{ height: '50px', overflow: 'hidden' }}
      />
    );
  };

  const handleBulkApprove = () => {
    const idPayload =
      data?.page === 'Information'
        ? { informationId: [data?._id] }
        : { mediaId: [data?._id] };

    setOpenModal({
      isOpen: true,
      header: `${data?.page} Approval`,
      title: `Approve ${data?.page}`,
      description: `Do you want to approve these  ${data?.page.toLowerCase()}`,
      ...idPayload,
      status: 'approved',
      icon: MFAImage,
    });
  };

  const handleBulkDecline = () => {
    const idPayload =
      data?.page === 'Information'
        ? { informationId: [data?._id] }
        : { mediaId: [data?._id] };

    setOpenModal({
      isOpen: true,
      header: `${data?.page} Approval`,
      title: `Decline ${data?.page}`,
      description: `Do you want to decline these ${data?.page.toLowerCase()}?`,
      ...idPayload,
      status: 'declined',
      icon: MFAImage,
    });
  };

  const handleReset = () => {
    dispatch(fetchNotifications(currentStatusFilter));
    onCancel();
  };

  const onCloseModalHandler = () => {
    setOpenModal((prev) => ({
      ...prev,
      mediaId: [],
      informationId: [],
      isOpen: false,
    }));
  };

  const getApprovalAction = (page) => {
    switch (page) {
      case 'Media':
        return bulkApprovalMedia;
      case 'Tenant':
        return bulkApprovalPoi;
      default:
        return bulkApprovalInformation;
    }
  };

  const onConfirm = () => {
    const action = getApprovalAction(data?.page);

    dispatch(
      action(
        {
          status: openModal.status,
          ids: [data?._id],
          siteId: data?.siteId,
        },
        () => {
          onCloseModalHandler();
          handleReset();
        }
      )
    );
  };

  return (
    <Fragment>
      {(data?.page === 'Media' || data?.page === 'Information' || data?.page === 'Tenant') && (
        <ModalConfirmation
          title={openModal.title}
          onCloseHandler={onCloseModalHandler}
          header={openModal.header}
          onConfirmHandler={onConfirm}
          description={openModal.description}
          visible={openModal.isOpen}
          icon={openModal.icon}
        />
      )}

      <Modal
        open={isVisible}
        title={null}
        footer={null}
        onCancel={onCancel}
        className="custom-modal detail-notification"
      >
        {data?.page === 'Media' ? (
          data?.logo && data?.fileType?.split('/')[0] === 'image' ? (
            <img
              src={`${imgUrl}/media/${data.logo}`}
              alt="post"
              style={{ maxHeight: '400px' }}
            />
          ) : data?.logo && data?.fileType?.split('/')[0] === 'video' ? (
            <video
              id="my-video"
              className="video-js"
              data-setup="{}"
              controls
              style={{ maxHeight: '400px' }}
            >
              <source src={`${imgUrl}/media/${data.logo}`} />
            </video>
          ) : null
        ) : data?.files?.length > 0 &&
          data?.files[0].fileType.includes('image') ? (
          <img
            src={`${imgUrl}/information/${data.files[0].logo}`}
            alt="post"
            style={{ maxHeight: '400px' }}
          />
        ) : data?.files?.length > 0 &&
          data?.files[0].fileType.includes('video') ? (
          <video
            id="my-video"
            className="video-js"
            data-setup="{}"
            controls
            style={{ maxHeight: '400px' }}
          >
            <source src={`${imgUrl}/information/${data.files[0].logo}`} />
          </video>
        ) : (
          <></>
        )}

        <div className="custom-modal-content">
          <h1 className="custom-modal-title">
            {data?.name ? data.name : 'No Title'}
          </h1>

          <div className="custom-modal-details">
            <ul>
              <li> {getStatus(data?.approval)}</li>
              {data?.page === 'Media' && (
                <li>
                  <ForwardIcon /> {data?.categoryName}
                </li>
              )}

              <li>
                <CalendarTickIcon />

                {data?.type === 'date'
                  ? `${moment(data?.start).format('MMM, D YYYY')} - ${moment(
                      data?.end
                    ).format('MMM, D YYYY')}`
                  : data?.type === 'day'
                  ? `${data?.days[0].day} - ${
                      data?.days[data?.days.length - 1].day
                    }`
                  : data?.start && data?.end
                  ? `${moment(data?.start).format('MMM, D YYYY')} - ${moment(
                      data?.end
                    ).format('MMM, D YYYY')}`
                  : 'All Day'}
              </li>
              <li>
                {data?.enableHtmlView ? (
                  <HtmlView htmlString={data?.description} />
                ) : (
                  <p className="card-list-subtitle">{data?.description}</p>
                )}
              </li>
            </ul>
          </div>
          <div className="btn-group">
            {data?.approval === 'pending' && (
              <>
                <button
                  className="btn-outline-primary"
                  onClick={handleBulkApprove}
                >
                  Approve
                </button>

                <button
                  className="btn-outline-danger"
                  onClick={handleBulkDecline}
                >
                  Decline
                </button>
              </>
            )}
          </div>
        </div>
      </Modal>
    </Fragment>
    // <Modal
    //   open={isVisible}
    //   title="Approve"
    //   onCancel={onCancel}
    //   className="notification-dialog"
    //   footer={
    //     <div className="notification-footer">
    //       <div className="row-data-footer" key="footer">
    //         <label className="label-preview">Admin's approval</label>
    //         <div>Switch to indicate that the notification has updated</div>
    //       </div>
    //       {/* <Switch
    //         onChange={onChange}
    //         checked={data && data.status === 'done'}
    //       /> */}
    //     </div>
    //   }
    //   closeIcon={<i className="feather-x" />}
    //   width={450}
    // >
    //   {data && (
    //     <div className="modal-content">
    //       {items.map((item) => (
    //         <div className="row-data" key={item.key}>
    //           <label className="label-preview">{item.label}</label>
    //           <div>{item.children}</div>
    //         </div>
    //       ))}
    //     </div>
    //   )}
    // </Modal>
  );
}

export default ModalDetailNotification;
